
// 每3位加逗号
const splitStr = data => {
  let strCash = data + ''; // 转换成字符串
  let retCash = '';
  let counter = 0;
  for (let i = strCash.length - 1; i >= 0; i--) {
    retCash = strCash.charAt(i) + retCash;
    counter++;
    if (counter === 3) {
      counter = 0;
      if (i !== 0) {
        retCash = ',' + retCash;
      };
    };
  };
  return retCash;
};
// 手机号格式化 3-4-4
const formatPhone = data => {
  if (!data) return '';
  return data.substr(0, 3) + ' ' + data.substr(3, 4) + ' ' + data.substr(7);
};
// 身份证格式化 111111*******0000
const formatID = data => {
  if (!data || data.toString().length !== 18) return '';
  return data.toString().replace(/^(.{6})(?:\d+)(.{4})$/, '$1******$2');
};

export { splitStr, formatPhone, formatID };
